// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"DevicesPage_pageContainer__3JE3Q","secondaryPageContainer":"DevicesPage_secondaryPageContainer__3IPON"};